import { ReactNode, useState } from "react";
import styles from "./MultiStepWizard.module.css";
import { Col, Container, Row } from "reactstrap";

const Step: React.FC<IStep> = ({index, children, isActive, stepTitle, dontHideInactive}) => {

  const getChildren = (): ReactNode => {
    if (dontHideInactive) return children;
    if (isActive) return children;
  }

  return (
    <div className={styles.wizardContainer}>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <div className={styles.flexContainer}>
              <span className={styles.circle}>
                {index + 1}
              </span>
              {stepTitle && 
                <span className={styles.titleContainer}>
                  { stepTitle }
                </span>
              }
            </div>
            
          </Col>
          <Col xs={12}>
            {getChildren()}
          </Col>
        </Row>
      </Container>
    </div>
      
   
  )
}

export default Step;

export interface IStep {
  index: number;
  isActive: boolean;
  dontHideInactive: boolean;
  children?: ReactNode;
  stepTitle?: string;
}